import cn from 'classnames'
import * as React from 'react'
import styles from './Sheet.module.css'
import { useIsContentScrollable } from './useIsContentScrollable'

export function Footer({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  const isContentScrollable = useIsContentScrollable()

  return (
    <div
      className={cn(
        styles.footer,
        {
          [styles.footerSticky]: isContentScrollable,
          [styles.footerNotSticky]: !isContentScrollable,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
